import { ChangeEvent, useState } from "react";

import { TimeRange } from "./types";

type TimeFilterProps = {
  onSave: (data: TimeRange) => void;
  defaultValue?: TimeRange;
};

const TimeFilter = ({ onSave, defaultValue }: TimeFilterProps) => {
  const [fromTime, setFromTime] = useState(defaultValue?.from || "");
  const [toTime, setToTime] = useState(defaultValue?.to || "");
  const [includeNulls, setIncludeNulls] = useState(
    defaultValue?.includeNulls || false
  );

  const handleFromTimeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newFromTime = e.target.value;
    setFromTime(newFromTime);

    // If toTime is empty or fromTime is greater than toTime, update toTime
    // (no longer auto-correcting toTime, to allow overnight ranges like 23:00 -> 01:00)
    onSave({
      from: newFromTime,
      to: toTime,
      includeNulls
    });
  };

  const handleToTimeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newToTime = e.target.value;

    // Ensure toTime is not less than fromTime
    // (no longer restricting toTime, to allow overnight ranges like 23:00 -> 01:00)
    setToTime(newToTime);

    onSave({
      from: fromTime,
      to: newToTime,
      includeNulls
    });
  };

  const handleIncludeNullsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newIncludeNulls = e.target.checked;
    setIncludeNulls(newIncludeNulls);

    onSave({
      from: fromTime,
      to: toTime,
      includeNulls: newIncludeNulls
    });
  };

  return (
    <div className="flex flex-col flex-1 min-h-0 mt-3">
      <div className="space-y-4">
        {/* From section */}
        <div className="space-y-3">
          <span className="text-sm font-bold">From</span>
          <div className="space-y-2">
            <input
              type="time"
              value={fromTime}
              onChange={handleFromTimeChange}
              className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
              aria-label="From Time"
            />
          </div>
        </div>

        {/* Until section */}
        <div className="space-y-3">
          <span className="text-sm font-bold">Until</span>
          <div className="space-y-2">
            <input
              type="time"
              value={toTime}
              onChange={handleToTimeChange}
              className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
              aria-label="To Time"
            />
          </div>
        </div>

        {/* Include Nulls checkbox */}
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={includeNulls}
            onChange={handleIncludeNullsChange}
            className="rounded border-gray-300 w-3.5 h-3.5 accent-primary-teal"
          />
          <span className="text-xs text-txtBody font-semibold">
            Include Nulls
          </span>
        </label>
      </div>
    </div>
  );
};

export default TimeFilter;
